'use strict';

angular
  .module('directives.employees', ['services.employees'])

  .directive('employee', [
    '$modal',
    'employeeService',
    function ($modal, employeeService) {
      return {
        scope: {
          employeeId: '=?',
          supervisorId: '=?',
          supervisorDelegateId: '=?',
          model: '=?',
          loadedModel: '=?',
          version: '=',
          service: '=?',
          withLink: '=?',
          layoutRatio: '&',
        },
        template: '<span ng-include="getTemplateUrl()"></div>',
        link: function (scope, elem, attrs) {
          scope.getTemplateUrl = function () {
            return (
              '/app/shared/components/directives/employeeDirective-' + attrs.version + '.tpl.html'
            );
          };

          var serviceToCall = employeeService.getEmployeePositionInHierarchy;

          scope.service = attrs.service || 'mini';
          if (scope.service === 'mini') {
            serviceToCall = employeeService.getEmployeeBasicInfos;
          }
          if (scope.service === 'pending') {
            serviceToCall = employeeService.getPendingEmployeeBasicInfos;
          }

          scope.layoutRatio = attrs.layoutRatio
            ? scope.$eval(attrs.layoutRatio)
            : {
                photoColumn: 'col-md-3',
                infosColumn: 'col-md-5',
                supervisorColumn: 'col-md-4',
              };

          if (angular.isDefined(scope.model)) {
            scope.employee = scope.model;

            scope.$watch('model', function (newValue, oldValue) {
              if (newValue !== oldValue) {
                scope.employee = scope.model;
              }
              setSupervisorAndDelegate(newValue);
            });
          } else {
            scope.$watch('employeeId', function (newValue, oldValue) {
              if (newValue) {
                serviceToCall(newValue).success(function (employee) {
                  scope.employee = employee;
                  scope.loadedModel = employee;
                  if (!scope.supervisorId) {
                    setSupervisorAndDelegate(employee);
                  }
                });
              }
            });
            scope.$watch('supervisorId', function (newValue, oldValue) {
              if (newValue) {
                serviceToCall(newValue).success(function (supervisor) {
                  scope.supervisor = supervisor;
                  if (!scope.supervisorDelegateId) {
                    scope.supervisorDelegateId = supervisor?.Delegate?.EmployeeID;
                  }
                });
              }
            });
          }

          scope.showPositionInHierarchyModal = showPositionInHierarchyModal;

          function setSupervisorAndDelegate(employee) {
            if (!employee) {
              return;
            }
            scope.supervisor = employee.Supervisor;
            scope.supervisorDelegateId = employee.Supervisor?.Delegate?.EmployeeID;
          }

          function showPositionInHierarchyModal() {
            if (scope.service === 'mini') {
              employeeService
                .getEmployeePositionInHierarchy(scope.employee.EmployeeID)
                .then(function (response) {
                  showModal(response.data);
                });
            } else {
              showModal(scope.employee);
            }

            function showModal(emp) {
              var modalScope = scope.$new(true);
              modalScope.employee = emp;

              var positionInHierarchyModal = $modal({
                scope: modalScope,
                template: require('../../../Main/employee/employeePositionInHierarchyModal.tpl.html'),
                placement: 'center',
                show: false,
              });
              positionInHierarchyModal.$promise.then(positionInHierarchyModal.show);
            }
          }
        },
      };
    },
  ]);
